import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { NotificationManager } from "react-notifications";
import { addNewCustomer, selectCustomer } from "../../redux/actions";
import NewCustomerAddressSection from "./NewCustomerAddressSection";
import { Redirect } from "react-router-dom";

const mapStateToProps = (state) => ({
  customers: state.customers,
});

const mapDispatchToProps = (dispatch) => ({
  addNewCustomer: (customer) => dispatch(addNewCustomer(customer)),
  selectCustomer: (customer) => dispatch(selectCustomer(customer)),
});

const FormInput = ({ label, type, placeholder, value, onChange }) => (
  <Col xs={6}>
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <FormControl
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </FormGroup>
  </Col>
);

const RegisterNewCustomer = ({ customers, addNewCustomer, selectCustomer }) => {
  const [customer, setCustomer] = useState({
    id: customers.length,
    addresses: [],
    orders: [],
    lastName: "",
    firstName: "",
    call: "",
    phone: "",
    code: "",
  });
  const [address, setAddress] = useState("");
  const [redirectToCustomerPage, setRedirectToCustomerPage] = useState(false);

  const handleInputChange = (name, value) => {
    if (["call", "phone", "code"].includes(name)) {
      value = convertToEnglishNumbers(value);
    }
    setCustomer((prev) => ({ ...prev, [name]: value }));
  };

  const addAddress = () => {
    if (address !== "") {
      setCustomer((prev) => ({
        ...prev,
        addresses: [...prev.addresses, address],
      }));
      setAddress("");
    }
  };

  const removeAddress = (index) => {
    setCustomer((prev) => ({
      ...prev,
      addresses: prev.addresses.filter((_, i) => i !== index),
    }));
  };

  const registerNewCustomer = async (e) => {
    e.preventDefault();
    if (validCustomer()) {
      window.server.emit("post_customer", customer, (data) => {
        if (data.code === 200) {
          NotificationManager.success(
            "مشتری جدید با موفقیت ثبت شد",
            "انجام شد"
          );
          setCustomer({
            id: customers.length,
            addresses: [],
            orders: [],
            lastName: "",
            firstName: "",
            call: "",
            phone: "",
            code: "",
          });
          selectCustomer(JSON.parse(data.response));
          setRedirectToCustomerPage(true);
        } else {
          NotificationManager.error(
            "مشکلی در ثبت مشتری. دوباره تلاش کنید",
            "نا موفق"
          );
        }
      });
    }
  };

  const convertToEnglishNumbers = (str) => {
    const numbersMap = {
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
    };

    return str.replace(/[۰۱۲۳۴۵۶۷۸۹٠١٢٣٤٥٦٧٨٩]/g, (num) => numbersMap[num]);
  };

  const validCustomer = () => {
    if (customer.lastName.length <= 0) {
      NotificationManager.error("طول نام خانوادگی باید وارد شود", "خطا");
      return false;
    }

    if (!customer.call && !customer.phone) {
      NotificationManager.error("یکی از شماره‌های تماس باید وارد شود", "خطا");
      return false;
    }

    if (customer.code <= 0) {
      NotificationManager.error("کد اشتراک باید وارد شود", "خطا");
      return false;
    }
    return true;
  };

  if (redirectToCustomerPage) {
    // Redirect to the customer detail page
    return <Redirect to="/info" />;
  }

  return (
    <Grid fluid style={{ marginTop: "30px" }}>
      <Row>
        <Col md={12}>
          <Card
            title="اضافه کردن مشتری جدید"
            content={
              <form onSubmit={registerNewCustomer}>
                <Row>
                  <FormInput
                    label="نام"
                    type="text"
                    placeholder="نام"
                    value={customer.firstName}
                    onChange={(e) =>
                      handleInputChange("firstName", e.target.value)
                    }
                  />
                  <FormInput
                    label="نام خانوادگی"
                    type="text"
                    placeholder="نام خانوادگی"
                    value={customer.lastName}
                    onChange={(e) =>
                      handleInputChange("lastName", e.target.value)
                    }
                  />
                </Row>
                <Row>
                  <FormInput
                    label="شماره همراه"
                    type="text"
                    placeholder="شماره همراه"
                    value={customer.call}
                    onChange={(e) => handleInputChange("call", e.target.value)}
                  />
                  <FormInput
                    label="تلفن ثابت"
                    type="text"
                    placeholder="تلفن ثابت"
                    value={customer.phone}
                    onChange={(e) => handleInputChange("phone", e.target.value)}
                  />
                </Row>
                <Row>
                  <FormInput
                    label="کد اشتراک"
                    type="text"
                    placeholder="کد اشتراک"
                    value={customer.code}
                    onChange={(e) => handleInputChange("code", e.target.value)}
                  />
                  <NewCustomerAddressSection
                    addAddress={addAddress}
                    setAddress={setAddress}
                    address={address}
                    customer={customer}
                    removeAddress={removeAddress}
                  />
                </Row>
                <Button bsStyle="info" type="submit" pullRight fill>
                  ثبت مشتری
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterNewCustomer);
